/* Esthétique v2: movimento (Motion Vogel). JS puro, sem biblioteca.
   Lê data-motion="reveal|stagger|parallax|tilt|magnetic|marquee|counter" e data-motion-delay (ms), e acrescenta
   sozinho: títulos cinéticos, história pinada (.ev2-steps), faixa gigante, microinterações de compra e cancelamento
   da transição de página no carrinho. Sem JS, ou com movimento reduzido, nada é escondido nem animado.
   Qualquer erro devolve a página ao estado estático. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var mqReduce = matchMedia('(prefers-reduced-motion: reduce)');
  if (mqReduce.matches || !('IntersectionObserver' in window)) return;
  var mqFine = matchMedia('(hover: hover) and (pointer: fine)');
  var mqDesk = matchMedia('(min-width: 768px)');
  var mqPin = matchMedia('(min-width: 1024px) and (min-height: 600px)');
  var off = false, raf = 0, hidden = [];
  var par = [], parLive = new Set(), bar = null, barFill = null;
  var story = null;

  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  function stop() {
    off = true;
    root.classList.remove('ev2-motion');
    if (bar) bar.style.display = 'none';
    if (story) story.disable();
    qa('.ev2m-run').forEach(function (e) { e.classList.remove('ev2m-run'); });
  }

  function init() {
    root.classList.add('ev2-motion');
    mark();
    story = setupStory();
    setupSplit();
    setupReveal();
    setupMarquee();
    setupParallax();
    setupProgress();
    setupCartBump();
    setupBuy();
    setupPageSwap();
    if (mqFine.matches) { setupTilt(); setupMagnetic(); }
    mqReduce.addEventListener('change', function (e) { if (e.matches) stop(); });
    doc.addEventListener('visibilitychange', function () { root.classList.toggle('ev2m-hidden', doc.hidden); });
    window.addEventListener('beforeprint', function () { hidden.forEach(show); });
    schedule();
  }

  /* Marcas que o tema não traz no HTML (o Estúdio e as listas de coleções são de outro dono). */
  function mark() {
    function set(sel, kind) { qa(sel).forEach(function (e) { if (!e.hasAttribute('data-motion')) e.setAttribute('data-motion', kind); }); }
    set('.ev2s__actions > .pg-button.ev2-btn:first-child', 'magnetic');
    set('.pg-collections-index__head, .pg-collections-index__section > h2', 'reveal');
    set('.pg-collections-index__specialties, .pg-collections-index__essentials', 'stagger');
  }

  /* ---------- Títulos de seção: palavras que sobem em stagger ---------- */
  var TITLES = '.ev2-h2, .pg-home-heading h2, .pg-prenatal-intro h2, .pg-folders-intro h2, .ev2-foot-top__line';
  function setupSplit() {
    var items = qa(TITLES).filter(function (h) { return !h.closest('dialog') && !h.closest('.ev2s') && !h.querySelector('.ev2m-w'); });
    if (!items.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        en.target.classList.add('ev2m-wi-on');
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    items.forEach(function (h) {
      var n = 0, w = doc.createTreeWalker(h, NodeFilter.SHOW_TEXT), nodes = [], t;
      while ((t = w.nextNode())) nodes.push(t);
      nodes.forEach(function (tn) {
        var frag = doc.createDocumentFragment();
        tn.nodeValue.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(doc.createTextNode(p)); return; }
          var a = doc.createElement('span'), b = doc.createElement('span');
          a.className = 'ev2m-w'; b.className = 'ev2m-wi';
          b.style.setProperty('--i', Math.min(n++, 14));
          b.textContent = p; a.appendChild(b); frag.appendChild(a);
        });
        tn.parentNode.replaceChild(frag, tn);
      });
      h.classList.add('ev2m-split');
      io.observe(h);
    });
  }

  /* ---------- História pinada: .ev2-steps (uma vez só) ---------- */
  function setupStory() {
    var sec = doc.querySelector('.ev2-steps'), wrap = sec && sec.querySelector(':scope > .ev2-wrap'),
      list = sec && sec.querySelector('.ev2-steps__list');
    if (!sec || !wrap || !list) return null;
    var steps = Array.prototype.slice.call(list.children), rail = null, fill = null, on = false, live = false,
      sraf = 0, top = 89, run = 0, cur = -1, T = [0, 0.2, 0.46, 0.72], counted = {};

    function header() { var h = doc.querySelector('.pg-header'); return h ? Math.round(h.getBoundingClientRect().height) : 89; }
    function size() {
      top = header();
      var stage = window.innerHeight - top;
      run = Math.round(window.innerHeight * 1.45);
      sec.style.setProperty('--ev2m-top', top + 'px');
      sec.style.setProperty('--ev2m-stage', stage + 'px');
      sec.style.setProperty('--ev2m-run', run + 'px');
    }
    function enable() {
      if (on) return true;
      size();
      sec.classList.add('ev2m-story');
      // Só vale se o conteúdo cabe na área fixa; senão volta à lista normal (síncrono, sem piscar).
      var a = wrap.firstElementChild.getBoundingClientRect(), z = wrap.lastElementChild.getBoundingClientRect();
      if (z.bottom - a.top > wrap.clientHeight - 56) { sec.classList.remove('ev2m-story'); return false; }
      on = true;
      list._ev2k = []; // a lista não é mais revelada pelo stagger comum
      steps.forEach(function (s) { s.classList.remove('ev2m-hide'); });
      rail = doc.createElement('div'); rail.className = 'ev2m-rail'; rail.setAttribute('aria-hidden', 'true');
      fill = doc.createElement('i'); rail.appendChild(fill); wrap.appendChild(rail);
      cur = -1; apply(true);
      return true;
    }
    function disable() {
      if (!on) return;
      on = false;
      sec.classList.remove('ev2m-story');
      ['--ev2m-top', '--ev2m-stage', '--ev2m-run'].forEach(function (p) { sec.style.removeProperty(p); });
      steps.forEach(function (s) { s.classList.remove('ev2m-pend', 'is-now'); });
      if (rail && rail.parentNode) rail.parentNode.removeChild(rail);
      rail = fill = null;
    }
    function apply(force) {
      if (!on) return;
      var r = sec.getBoundingClientRect(), p = clamp((top - r.top) / run, 0, 1), idx = 0, i;
      for (i = 1; i < T.length; i++) if (p >= T[i]) idx = i;
      if (fill) fill.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      if (idx === cur && !force) return;
      cur = idx;
      steps.forEach(function (s, k) {
        s.classList.toggle('ev2m-pend', k > idx);
        s.classList.toggle('is-now', k === idx);
        var c = k <= idx && s.querySelector('[data-motion="counter"]');
        if (c && !counted[k]) { counted[k] = true; count(c); }
      });
    }
    function tick() { sraf = 0; apply(false); }
    function onScroll() { if (on && live && !sraf) sraf = requestAnimationFrame(tick); }
    function evaluate() {
      if (off) return;
      if (!mqPin.matches) { disable(); return; }
      if (on) { size(); apply(true); } else enable();
    }
    new IntersectionObserver(function (en) { live = en[0].isIntersecting; if (live) onScroll(); }, { rootMargin: '10% 0px' }).observe(sec);
    window.addEventListener('scroll', onScroll, { passive: true });
    var rz = 0;
    window.addEventListener('resize', function () { if (!rz) rz = requestAnimationFrame(function () { rz = 0; evaluate(); }); }, { passive: true });
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function () { if (!on) evaluate(); });
    evaluate();
    return { disable: disable, active: function () { return on; } };
  }

  /* ---------- Revelações, stagger e contadores ---------- */
  function setupReveal() {
    var handled = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        show(en.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.01 });

    function reg(el, kids) {
      if (handled.has(el)) return;
      handled.add(el);
      if (story && story.active() && el.closest('.ev2m-story') && el.matches('.ev2-steps__list')) return; // quem manda é a história
      if (kids) {
        var list = Array.prototype.slice.call(el.children);
        list.forEach(function (k) { handled.add(k); k.classList.add('ev2m-hide'); });
        el._ev2k = list;
      } else {
        el.classList.add('ev2m-hide');
        // O título do cabeçalho já sobe palavra por palavra: o bloco só aparece, com deslocamento mínimo.
        if (el.querySelector('.ev2m-split')) el.style.setProperty('--ev2m-d', '8px');
      }
      hidden.push(el);
      io.observe(el);
    }
    // Foco de teclado em algo ainda escondido (trilho horizontal, por exemplo): mostra na hora.
    doc.addEventListener('focusin', function (e) {
      var h = e.target.closest && e.target.closest('.ev2m-hide');
      if (h) { io.unobserve(h); show(h); }
    });
    qa('[data-motion="stagger"]').forEach(function (el) { reg(el, true); });
    qa('[data-motion="reveal"]').forEach(function (el) { reg(el, false); });

    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        cio.unobserve(en.target);
        count(en.target);
      });
    }, { threshold: 0.6 });
    qa('[data-motion="counter"]').forEach(function (el) {
      if (story && story.active() && el.closest('.ev2m-story')) return; // a história conta quando o passo chega
      cio.observe(el);
    });
  }

  function show(el) {
    var step = 60, cap = 480;
    if (el._ev2k) {
      el._ev2k.forEach(function (k, i) { play(k, Math.min(i * step, cap)); });
    } else {
      play(el, parseInt(el.getAttribute('data-motion-delay'), 10) || 0);
    }
  }
  function play(el, delay) {
    el.style.setProperty('--ev2m-delay', delay + 'ms');
    el.classList.remove('ev2m-hide');
    el.classList.add('ev2m-in');
    el.addEventListener('animationend', function done(e) {
      if (e.target !== el || e.animationName !== 'ev2m-rise') return;
      el.removeEventListener('animationend', done);
      el.classList.remove('ev2m-in');
      el.style.removeProperty('--ev2m-delay');
    });
  }

  function count(el) {
    var n = parseInt(el.getAttribute('data-count'), 10);
    if (!(n > 0) || n > 999) return; // só inteiros reais
    el.style.fontVariantNumeric = 'tabular-nums';
    if (String(n).length > 1) { // números de 2 ou mais dígitos: trava a largura para não mexer na linha
      el.style.display = 'inline-block';
      el.style.minWidth = el.getBoundingClientRect().width + 'px';
    }
    el.textContent = '0';
    var t0 = 0, dur = 800, wait = 320;
    function frame(t) {
      if (off) { el.textContent = n; return; }
      if (!t0) t0 = t + wait;
      var p = clamp((t - t0) / dur, 0, 1);
      el.textContent = Math.round(n * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ---------- Faixa corrida gigante ---------- */
  function setupMarquee() {
    qa('[data-motion="marquee"]').forEach(function (el) {
      var track = el.querySelector('.ev2-ribbon__track'), list = el.querySelector('.ev2-ribbon__list');
      if (!list || !track) return;
      qa('li', el).forEach(function (li) { li.setAttribute('data-t', li.textContent); }); // texto do preenchimento no hover
      function measure() {
        var w = list.getBoundingClientRect().width;
        if (w > 0) el.style.setProperty('--ev2m-dur', Math.max(24, w / 64).toFixed(1) + 's'); // ~64 px/s
      }
      measure();
      window.addEventListener('resize', measure, { passive: true });
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(measure);
      el.classList.add('ev2m-run');
      new IntersectionObserver(function (en) {
        el.classList.toggle('ev2m-off', !en[0].isIntersecting);
      }).observe(el);
      // Hover: a faixa desacelera de forma suave (updatePlaybackRate) em vez de travar.
      var anim = null, rate = 1, goal = 1, rr = 0;
      function getAnim() {
        if (anim) return anim;
        if (!track.getAnimations) return null;
        anim = track.getAnimations().filter(function (a) { return a.animationName === 'ev2m-marquee'; })[0] || null;
        return anim;
      }
      function ramp() {
        rr = 0;
        var a = getAnim(); if (!a) return;
        rate += (goal - rate) * 0.1;
        if (Math.abs(goal - rate) < 0.01) rate = goal;
        a.updatePlaybackRate(rate);
        if (rate !== goal) rr = requestAnimationFrame(ramp);
      }
      if (mqFine.matches && getAnim()) {
        el.classList.add('ev2m-ramp');
        el.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'mouse') return; goal = 0.08; if (!rr) rr = requestAnimationFrame(ramp); });
        el.addEventListener('pointerleave', function () { goal = 1; if (!rr) rr = requestAnimationFrame(ramp); });
      }
    });
  }

  /* ---------- Parallax ---------- */
  function setupParallax() {
    var items = qa('[data-motion="parallax"]').map(function (el) { return { el: el, amp: 0, px: 36 }; });
    qa('.pg-svc-hero').forEach(function (el) { items.push({ el: el, amp: 0, px: 20 }); });
    if (!items.length) return;
    par = items;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var it = en.target._ev2p;
        if (en.isIntersecting) { parLive.add(it); it.el.classList.add('ev2m-live'); it.el.classList.remove('ev2m-off'); }
        else { parLive.delete(it); it.el.classList.remove('ev2m-live'); it.el.classList.add('ev2m-off'); }
      });
      schedule();
    }, { rootMargin: '10% 0px' });
    items.forEach(function (it) { it.el._ev2p = it; io.observe(it.el); });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
  }

  function schedule() { if (!raf && !off) raf = requestAnimationFrame(frame); }

  function frame() {
    raf = 0;
    if (off) return;
    var vh = window.innerHeight, desk = mqDesk.matches, i, it, r, p, y, rs = [];
    // leitura
    parLive.forEach(function (it2) { rs.push([it2, it2.el.getBoundingClientRect()]); });
    var sy = window.pageYOffset, max = doc.documentElement.scrollHeight - vh;
    // escrita
    for (i = 0; i < rs.length; i++) {
      it = rs[i][0]; r = rs[i][1];
      if (!desk) { it.el.style.removeProperty('--ev2m-y'); continue; }
      p = clamp(((vh / 2) - (r.top + r.height / 2)) / ((vh + r.height) / 2), -1, 1);
      y = -p * (it.amp ? it.amp * r.height : it.px);
      it.el.style.setProperty('--ev2m-y', y.toFixed(1) + 'px');
    }
    if (bar) {
      var pr = max > 0 ? clamp(sy / max, 0, 1) : 0;
      barFill.style.transform = 'scaleX(' + pr.toFixed(4) + ')';
      bar.classList.toggle('is-on', sy > 80 && max > vh * 1.5);
    }
  }

  /* ---------- Indicador de progresso ---------- */
  function setupProgress() {
    if (/^\/(cart|checkouts?)\b/.test(location.pathname)) return;
    bar = doc.createElement('div');
    bar.className = 'ev2m-progress';
    bar.setAttribute('aria-hidden', 'true');
    barFill = doc.createElement('i');
    bar.appendChild(barFill);
    doc.body.appendChild(bar);
    window.addEventListener('scroll', schedule, { passive: true });
  }

  /* ---------- Inclinação dos cartões de área ---------- */
  function setupTilt() {
    qa('[data-motion="tilt"]').forEach(function (el) {
      var rect, tx = 0, ty = 0, cx = 0, cy = 0, live = false, run = 0, MAX = 5;
      function loop() {
        run = 0;
        cx += (tx - cx) * 0.14; cy += (ty - cy) * 0.14;
        var done = !live && Math.abs(cx) < 0.02 && Math.abs(cy) < 0.02;
        el.style.transform = done ? '' : 'perspective(900px) rotateX(' + cy.toFixed(2) + 'deg) rotateY(' + cx.toFixed(2) + 'deg)';
        if (!done) run = requestAnimationFrame(loop);
      }
      el.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || off) return;
        rect = el.getBoundingClientRect(); live = true; if (!run) run = requestAnimationFrame(loop);
      });
      el.addEventListener('pointermove', function (e) {
        if (!live || !rect) return;
        tx = ((e.clientX - rect.left) / rect.width - 0.5) * 2 * MAX;
        ty = -((e.clientY - rect.top) / rect.height - 0.5) * 2 * MAX;
      });
      el.addEventListener('pointerleave', function () { live = false; tx = ty = 0; if (!run) run = requestAnimationFrame(loop); });
    });
  }

  /* ---------- Botões magnéticos ---------- */
  function setupMagnetic() {
    var items = qa('[data-motion="magnetic"]').map(function (el) { return { el: el, x: 0, y: 0, tx: 0, ty: 0, r: null }; });
    if (!items.length) return;
    var mx = 0, my = 0, run = 0, dirty = true, MAXPX = 7;
    function tick() {
      run = 0;
      var again = false;
      items.forEach(function (it) {
        if (off) { it.tx = it.ty = 0; }
        it.x += (it.tx - it.x) * 0.18; it.y += (it.ty - it.y) * 0.18;
        var settled = Math.abs(it.x - it.tx) < 0.05 && Math.abs(it.y - it.ty) < 0.05;
        if (settled && !it.tx && !it.ty) { if (it.el.style.transform) it.el.style.transform = ''; }
        else { it.el.style.transform = 'translate3d(' + it.x.toFixed(2) + 'px,' + it.y.toFixed(2) + 'px,0)'; again = true; }
      });
      if (again) run = requestAnimationFrame(tick);
    }
    function aim() {
      var vh = window.innerHeight, any = false;
      items.forEach(function (it) {
        if (dirty || !it.r) it.r = it.el.getBoundingClientRect();
        var r = it.r, pad = 70;
        if (r.bottom < -pad || r.top > vh + pad) { it.tx = it.ty = 0; return; }
        var dx = mx - (r.left + r.width / 2), dy = my - (r.top + r.height / 2);
        var near = Math.abs(dx) < r.width / 2 + pad && Math.abs(dy) < r.height / 2 + pad;
        it.tx = near ? clamp(dx * 0.22, -MAXPX, MAXPX) : 0;
        it.ty = near ? clamp(dy * 0.22, -MAXPX, MAXPX) : 0;
        if (it.tx || it.ty) any = true;
      });
      dirty = false;
      if (!run) run = requestAnimationFrame(tick);
      return any;
    }
    var pend = 0;
    doc.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || off) return;
      mx = e.clientX; my = e.clientY;
      if (!pend) pend = requestAnimationFrame(function () { pend = 0; aim(); });
    }, { passive: true });
    function mark2() { dirty = true; items.forEach(function (it) { it.r = null; }); }
    window.addEventListener('scroll', mark2, { passive: true });
    window.addEventListener('resize', mark2, { passive: true });
  }

  /* ---------- Contador do carrinho ---------- */
  function setupCartBump() {
    var links = qa('.pg-cart-link, a[href$="/cart"]');
    if (!links.length || !('MutationObserver' in window)) return;
    var prev = new WeakMap(), first = true;
    function scan() {
      qa('.pg-count').forEach(function (c) {
        var t = (c.textContent || '').trim(), old = prev.get(c);
        prev.set(c, t);
        if (!t || old === t) return;
        if (old === undefined && first) return; // estado inicial da página
        c.classList.remove('ev2m-bump'); void c.offsetWidth; c.classList.add('ev2m-bump');
        c.addEventListener('animationend', function () { c.classList.remove('ev2m-bump'); }, { once: true });
      });
    }
    scan(); first = false;
    var mo = new MutationObserver(scan);
    links.forEach(function (l) { mo.observe(l, { childList: true, characterData: true, subtree: true }); });
  }

  /* ---------- Compra: escolha de quantidade e troca de preço ---------- */
  function setupBuy() {
    doc.addEventListener('change', function (e) {
      var i = e.target;
      if (off || !i || i.type !== 'radio' || !i.closest || !i.closest('.pg-variants')) return;
      var s = i.nextElementSibling;
      if (!s || s.tagName !== 'SPAN') return;
      s.classList.remove('ev2m-pick'); void s.offsetWidth; s.classList.add('ev2m-pick');
      s.addEventListener('animationend', function () { s.classList.remove('ev2m-pick'); }, { once: true });
    });
    if (!('MutationObserver' in window)) return;
    function tick(el) {
      if (off) return;
      el.classList.remove('ev2m-tick'); void el.offsetWidth; el.classList.add('ev2m-tick');
      el.addEventListener('animationend', function () { el.classList.remove('ev2m-tick'); }, { once: true });
    }
    qa('.pg-price-box, [data-sticky-price]').forEach(function (el) {
      new MutationObserver(function () { tick(el); }).observe(el, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['amount'] });
    });
  }

  /* ---------- Transição de página: não anima carrinho, conta, recarga nem voltar/avançar ---------- */
  function setupPageSwap() {
    window.addEventListener('pageswap', function (e) {
      var vt = e.viewTransition;
      if (!vt) return;
      try {
        var act = e.activation, to = act && act.entry && new URL(act.entry.url).pathname, type = act && act.navigationType;
        if (!to || type === 'reload' || type === 'traverse' || /^\/(cart|checkouts?|account|orders)\b/.test(to) || /^\/(cart|checkouts?|account|orders)\b/.test(location.pathname)) vt.skipTransition();
      } catch (err) { vt.skipTransition(); }
    });
  }

  function boot() { try { init(); } catch (e) { stop(); } }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
